<template>
  <div class="col-12">
    <div class="text-left">
      <button class="btn btn-fg btn-add custom-shadow-btn" @click="handleAdd">
        <em class="fa fa-plus"></em>
        {{ $t('common_words.add') }} {{ getBtnTitle }}
      </button>
    </div>
    <hr />
  </div>
</template>

<script>
import i18n from '../../i18n';
export default {
  name: 'header-add',
  props: {
    btnTitle: {
      type: String,
      default: null,
    },
    route: {
      type: String,
      default: '',
    },
    typeEvent: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    getBtnTitle() {
      return this.btnTitle ? this.btnTitle : i18n.t('common_words.new_record');
    },
    getRouteProp() {
      return this.route || '';
    },
    getTypeEventProp() {
      return this.typeEvent || 0;
    },
  },
  methods: {
    handleAdd() {
      switch (this.getTypeEventProp) {
        case 1:
          this.$router.push(this.getRouteProp);
          break;

        case 2:
          this.$emit('createModel');
          break;

        default:
          this.$emit('openModal', 'create');
          break;
      }
    },
  },
};
</script>
